module.exports = __webpack_public_path__ + "static/media/The-Museum-Job.64a1275d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rimages/The-Museum-Job.jpg
// module id = 69
// module chunks = 0